interface IconProps {
  color?: string
  className?: string
}

export default function FunnelIcon({ color, className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M156.444444 103.480889C156.444444 53.475556 196.266667 12.970667 245.333333 12.970667h533.333334c49.095111 0 88.888889 40.504889 88.888889 90.510222v97.735111c0 66.076444-28.330667 128.853333-77.596445 171.804444l-157.781333 137.728 157.781333 137.699556a228.010667 228.010667 0 0 1 77.596445 171.804444v97.763556c0 49.976889-39.822222 90.510222-88.888889 90.510222H245.333333a88.092444 88.092444 0 0 1-62.862222-26.510222 91.335111 91.335111 0 0 1-26.026667-64v-97.735111c0-66.048 28.359111-128.796444 77.596445-171.804445l157.781333-137.728-157.781333-137.699555A228.010667 228.010667 0 0 1 156.444444 201.216V103.480889z m622.222223 0H245.333333v97.735111a136.817778 136.817778 0 0 0 46.592 103.082667l157.752889 137.699555a91.192889 91.192889 0 0 1 31.061334 68.721778c0 26.424889-11.349333 51.512889-31.061334 68.721778l-157.752889 137.756444a136.817778 136.817778 0 0 0-46.592 103.082667v97.735111h533.333334v-97.735111a136.817778 136.817778 0 0 0-46.592-103.082667l-157.752889-137.756444a91.192889 91.192889 0 0 1-31.061334-68.721778c0-26.424889 11.349333-51.512889 31.061334-68.721778l157.752889-137.671111a136.817778 136.817778 0 0 0 46.592-103.111111V103.480889z"
        fill={color}
      />
      <path
        d="M464.270222 624.867556a45.824 45.824 0 0 1 67.015111 0l94.833778 99.555555c13.539556 14.250667 17.607111 35.669333 10.268445 54.243556-7.338667 18.602667-24.604444 30.72-43.804445 30.72h-189.639111c-19.171556 0-36.437333-12.117333-43.804444-30.72a51.598222 51.598222 0 0 1 10.296888-54.243556l94.833778-99.555555z"
        fill={color}
      />
    </svg>
  )
}
